import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AddCall } from 'src/providers/addvCall';
import { ServicesProvider } from 'src/providers/services';

@Component({
  selector: 'app-medication',
  templateUrl: './medication.page.html',
  styleUrls: ['./medication.page.scss'],
})
export class MedicationPage implements OnInit {

  presentView: any;
  headerValue: any;
  backValue: any;
  brightness1: boolean;
  brightness2: boolean;
  brightness3: boolean;

  constructor(public router: Router,
    private services: ServicesProvider,
    public addCall: AddCall) { }

  ngOnInit() {
  }

  doRefresh(event) {
    console.log('Begin async operation');

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  // ------------------some special functions---------------
  brightnessMode(value) {
    if (value == "Low") {
      this.brightness1=!this.brightness1;
      this.brightness2=false;
      this.brightness3=false;
    }
    else if (value == "Mid") {
      this.brightness1=false;
      this.brightness2=!this.brightness2;
      this.brightness3=false;
    }
    else if (value == "Nit") {
      this.brightness1=false;
      this.brightness2=false;
      this.brightness3=!this.brightness3;
    }
  }

  ionViewWillEnter() {
    this.presentView = "medication";
    this.headerValue = "Medication";
    this.backValue = "goPregMo";
  }


  openPatientMeditation() {
    this.presentView = "patientMedication";
    this.headerValue = "Dala Medication";
    this.backValue = "goList";
  }

  getMedicationList() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "morningSession": true,
      "afternoonSession": false,
      "nightSession": false
    });
    this.services.postRequest("medicationPatientList", apiData).subscribe(res => {
      console.log(res);
    });
  }

  goBack(value) {
    switch (value) {
      case "goList": {
        this.ionViewWillEnter();
        break;
      }
      case "goPregMo": {
        this.router.navigate(['/tabs/pregnant-mother']);
        break;
      }
    }
  }
}
